import React from "react";

import { Context, fetchClasses } from "../../../teacherStore";
import TeachingClassList from "../../../templates/teacher/TeachingClassList";
import { parseQueryParams } from "../../../libs/Util";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const classListInParams = parseQueryParams()["classList"];
  const selectedClassIds: number[] = React.useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  React.useEffect(() => {
    dispatch(fetchClasses());
  }, [dispatch]);

  return (
    <TeachingClassList
      classes={state.classes}
      selectedClassIds={selectedClassIds}
    />
  );
};
